// GetPageMetaData returns the meta data for a basket page.
export const BasketMetaService_GetPageMetaDataLazy = () =>
  import("./service.grpc").then((m) => m.BasketMetaService_GetPageMetaData);
BasketMetaService_GetPageMetaDataLazy.method =
  "aysa_api.services.basket.v1.page.meta.BasketMetaService/GetPageMetaData" as const;
